import { RootState } from '../rootReducer';

export const selectCurrentStep = (state: RootState) => state.formProgress.formProgress.currentStep;
export const selectCompletedSteps = (state: RootState) => state.formProgress.formProgress.completedSteps;
export const selectTermsAccepted = (state: RootState) => state.formProgress.formProgress.termsAccepted;
